<template>
  <v-app id="inspire">
    <v-content>
      <v-container class="fill-height" fluid v-if="!legacymode">
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4" lg="3">
            <v-alert v-if="warning" type="error">{{ warning }}</v-alert>
            <v-card class="elevation-12">
              <v-toolbar flat>
                <v-toolbar-title>Bejelentkezés</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-form v-on:keyup.enter="login">
                  <v-text-field
                      label="Felhasználónév"
                      name="login"
                      prepend-icon="mdi-account"
                      autocomplete="login"
                      type="text"
                      v-model="username"
                      v-on:keyup.enter="login"
                  ></v-text-field>
                  <v-text-field
                      id="password"
                      label="Jelszó"
                      name="password"
                      prepend-icon="mdi-lock"
                      type="password"
                      autocomplete="current-password"
                      v-model="password"
                      v-on:keyup.enter="login"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn depressed v-on:click="login">Bejelentkezés</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
    <v-overlay :value="legacymode||overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
      <h4 v-html="connection_status" style="text-align: center; margin-top: 20px;"></h4>
    </v-overlay>

    <v-row justify="center" v-show="nomatchDialog" class="dialog-container">
      <v-dialog v-model="nomatchDialog" persistent max-width="300">
        <v-card tile flat>
          <v-card-title class="headline">Hiba</v-card-title>
          <v-card-text>Nem található aktív esemény.</v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn depressed tile @click="nomatchDialogClose">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-app>
</template>

<script>
import Bugsnag from "@bugsnag/js";
import eventBus from '@/eventBus';
import CONSTANTS from '@/constants';
import {mapGetters, mapMutations, mapState} from "vuex";

var debug = console.log;

export default {
  data: () => ({
    username: "",
    password: "",
    warning: "",
    connection_status: "Csatlakozás a szerverhez... <br/>",
  }),
  name: "LoginScreen",
  props: {
    source: String
  },
  computed: {
    ...mapState('ui', ['nomatchDialog', 'legacymode', 'overlay']),
    ...mapState('connection', ['user']),
    ...mapGetters('connection', ['getUser'])
  },
  created() {
    const self = this;
    this.$emit("changeOnPeriodChangeability", false);

    window.vueio.on("nomatchfound", () => {
      self.SET_OVERLAY(false);
      self.SET_NOMATCH_DIALOG(true);
    })
    window.vueio.on(CONSTANTS.SOCKET.ACTIONS.CONNECT, data => {
      this.connection_status += "Csatlakozva a sockethez... <br/>";
      this.socket_connect(data);
    });
    window.vueio.on(CONSTANTS.SOCKET.ACTIONS.LOGINSUCCESS, data => {
      this.connection_status += "Felhasználó sikeresen bejelentkezett... <br/>";
      this.socket_login_success(data);
    });
    window.vueio.on(CONSTANTS.SOCKET.ACTIONS.LOGINERROR, data => {
      this.socket_login_error(data);
    });
    window.vueio.on(CONSTANTS.SOCKET.ACTIONS.USERDATA, data => {
      this.socket_userdata(data);
    });
    window.vueio.on(CONSTANTS.SOCKET.ACTIONS.LOGOUT, data => {
      debug("thrown out by server", data);
      window.forceClean();
    });
    window.vueio.on(CONSTANTS.SOCKET.ACTIONS.NOPERMISSION, () => {
      this.$router.push('no-permission').catch(() => {
      });
    });
    window.vueio.on(CONSTANTS.SOCKET.ACTIONS.NOTSTARTED, () => {
      window.dmrForceLogout();
    });


    //login után az init data
    window.vueio.on(CONSTANTS.SOCKET.ACTIONS.INIT, data => {
      const user = self.getUser;
      debug('loginchange', data);
      self.connection_status += "BO adatok inicializálva.... <br/>";

      // JAVÍTÁS: KORÁBBAN itt, a bejövő NYERS init adatban cseréltük le a
      // hosszabbítás-periódusok feliratait ("Első hosszabbítás..." -> "O.T.
      // Első...") - ez azonban azt jelentette, hogy a MÓDOSÍTOTT szöveg
      // került bele a helyi "init" rekordba, ami aztán a normál szinkron-
      // mechanizmuson keresztül FEL IS TÖLTŐDÖTT a szerverre - vagyis a
      // ténylegesen TÁROLT, hivatalos mérkőzésadat is a rövidített feliratot
      // kapta, nem csak ennek a kliensnek a kijelzése. Mivel a LiveScore
      // ugyanebből a tárolt adatból dolgozik, az is a rövidített feliratot
      // kapta - holott a cél kizárólag a CR/DMR/SUB felületek megjelenítése
      // volt. A javítás: a nyers adatot ÉRINTETLENÜL hagyjuk (az eredeti,
      // teljes felirat kerül tárolásra/szinkronizálásra), a rövidítést pedig
      // KIZÁRÓLAG a megjelenítési rétegben (l. src/utils/periodLabel.js)
      // alkalmazzuk, ott, ahol a periódusneveket ténylegesen kiírjuk.
      window.dbmanager.gamedataCallback(data).then(() => {
        self.SET_OVERLAY(false);
        window.username = user.username;
        window.usertype = user.type;

        self.connection_status += "Lokális adatbázis felépítve... <br/>";

        //setTimeout(function () {
        if (user.type === "cr") {
          self.$router.push("/report").catch(() => {
          });
        } else if (user.type === "sub") {
          self.$router.push("/substitute").catch(() => {
          });
        } else if (user.type === "dmr") {
          self.$router.push("/dmr").catch(() => {
          });
        }
        //}, 10000);

        eventBus.$emit(CONSTANTS.EVENTS.LOGIN.CHANGE, true);
      });

      if (data && data.periods) {
        if (data.extra_time_1 === false) {
          let index = data.periods.findIndex(period => period.value === "5")
          if (index !== -1) {
            data.periods.splice(index, 1);
          }
          index = data.periods.findIndex(period => period.value === "6")
          if (index !== -1) {
            data.periods.splice(index, 1);
          }
          index = data.periods.findIndex(period => period.value === "7")
          if (index !== -1) {
            data.periods.splice(index, 1);
          }
          index = data.periods.findIndex(period => period.value === "8")
          if (index !== -1) {
            data.periods.splice(index, 1);
          }
        }
        if (data.extra_time_2 === false) {
          let index = data.periods.findIndex(period => period.value === "9")
          if (index !== -1) {
            data.periods.splice(index, 1);
          }
          index = data.periods.findIndex(period => period.value === "10")
          if (index !== -1) {
            data.periods.splice(index, 1);
          }
          index = data.periods.findIndex(period => period.value === "11")
          if (index !== -1) {
            data.periods.splice(index, 1);
          }
        }
        if (data.penalty === false) {
          let index = data.periods.findIndex(period => period.value === "12")
          if (index !== -1) {
            data.periods.splice(index, 1);
          }
        }

        if (data.extra_time_1 === false && data.extra_time_2 === false && data.penalty === false) {
          let index = data.periods.findIndex(period => period.value === "4")
          if (index !== -1) {
            data.periods.splice(index, 1);
          }
        }

        if (data.periods) {
          data.periods.forEach(function (period, index) {
            data.periods[index].disabled = data.rule === 'STRAND' ? period.value === '12' : false; //szétlövés disabled
            data.periods[index].order = parseInt(period.value);
          });

          data.periods.sort(function (a, b) {
            let order1 = parseInt(a.order);
            let order2 = parseInt(b.order);
            if (order1 > order2 || order1 === order2) {
              return 1;
            }
            return -1;
          });
        }
        // JAVÍTÁS: a periodItems (amit a Period.vue legördülője és a
        // TimelineList.vue az esemény-listák periódus-feliratához használ)
        // NEM ugyanazokat az objektumokat kapja, mint a `data.periods` -
        // hanem egy ÚJ, sekély másolatot minden periódusról, aminek
        // KIZÁRÓLAG a `text` mezője rövidül le ("O.T." forma). Így a
        // ténylegesen tárolt/szinkronizált `data.periods` (és az abból
        // épülő `gamedata.periods`, amit pl. a LiveScore is használ)
        // teljesen érintetlen marad az eredeti, teljes felirattal.
        const shortenPeriodText = require('@/utils/periodLabel').shortenPeriodText;
        const displayPeriodItems = Array.isArray(data.periods)
            ? data.periods.map(period => ({...period, text: shortenPeriodText(period.text)}))
            : data.periods;
        eventBus.$emit(CONSTANTS.EVENTS.PERIOD.SET.ITEMS, displayPeriodItems);
      }
    });

    if (window.config.loginmethod == "backoffice") {
      this.LOGINVbackoffice();
    }
  },
  methods: {
    ...mapMutations('ui', ['SET_NOMATCH_DIALOG', 'SET_OVERLAY', 'SET_LEGACYMODE']),
    ...mapMutations('connection', ['SET_USER', 'SET_ROOMSIZE', 'SET_DBNAME']),
    LOGINVbackoffice() {
      this.SET_LEGACYMODE(true);
      let data = {};
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      data.merkozesid = urlParams.get('merkozesId');
      data.felulet = urlParams.get('felulet');
      data.azon = urlParams.get('userId');
      if (urlParams.get('token')) {
        data.cookie = urlParams.get('token');
        this.$cookies.set("MKSZ-AUTH", data.cookie);
        window.onbeforeunload = null;
        window.location = window.location.protocol + "//" + window.location.hostname + ":" + window.location.port + "/?merkozesId=" + data.merkozesid + "&felulet=" + data.felulet + "&azon=" + data.azon;
      } else {
        data.cookie = this.getCookie('MKSZ-AUTH');
      }
      window.vueio.emit("LOGINVbackoffice", data);
    },
    nomatchDialogClose() {
      this.SET_NOMATCH_DIALOG(false);
    },
    socket_connect(data) {
      const user = this.getUser;
      if (user && typeof user.id !== "undefined") {
        debug(user);

        window.vueio.emit(CONSTANTS.SOCKET.ACTIONS.LOGIN, {
          id: user.id
        });
      }
      debug("connected", data);
    },
    socket_login_success(data) {
      debug("login success", data);
    },
    socket_login_error(data) {
      this.SET_OVERLAY(false);
      this.warning = "Hibás felhasználó név, vagy jelszó.";
      debug(data);
    },
    socket_userdata(data) {
      const url = new URL(window.location.href); // or any URL string
      const params = new URLSearchParams(url.search);

      this.SET_USER(data);
      const self = this;

      Bugsnag.setUser(params.get('azon'), data.type, params.get('merkozesId'));
      Bugsnag.notify("logged in: " + params.get('merkozesId'), async function (event) {
        event.severity = 'info';
        event.context = 'Login - ' + params.get('azon') + ' => ' + data.type;
        event.setUser(params.get('azon'), data.type, params.get('merkozesId'));
        event.addMetadata('socket_userdata', data);

        let navigatorData = {};

        navigatorData.name = navigator.userAgent;
        navigatorData.platform = navigator.platform;
        navigatorData.connection = {};
        if (navigator.connection && navigator.connection.downlink) {
          navigatorData.connection.downlink = navigator.connection.downlink;
          navigatorData.connection.effectiveType = navigator.connection.effectiveType;
          navigatorData.connection.rtt = navigator.connection.rtt;
        }
        navigatorData.cookieEnabled = navigator.cookieEnabled;

        const screenWidth = screen.width;
        const screenHeight = screen.height;
        navigatorData.screenWidth = screenWidth;
        navigatorData.screenHeight = screenHeight;

        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;

        navigatorData.viewportWidth = viewportWidth;
        navigatorData.viewportHeight = viewportHeight;

        const speed = await self.measureDownloadSpeed();
        navigatorData.downloadSpeed = speed.downloadSpeed; // Mbps, a ténylegesen letöltött adatból
        navigatorData.downloadTtfbMs = speed.ttfbMs;
        navigatorData.downloadBytes = speed.bytes;
        navigatorData.downloadDurationMs = speed.durationMs;

        event.addMetadata('navigator_data', navigatorData);


      });

      window.roomsize = data.roomsize;
      window.dbname = data.room;
      this.SET_ROOMSIZE(data.roomsize);
      this.SET_DBNAME(data.room);

      // JAVÍTÁS (2026-09-21 - az újrapróbálkozás VISSZAVONVA): korábban itt
      // három próbálkozás futott (1 + 2, növekvő várakozással), abból a
      // feltevésből, hogy a blokkolás gyakran csak ÁTMENETI. A feltevés
      // részben igaz, a megvalósítás viszont ROSSZABBÁ tette a helyzetet:
      //
      // Egy `indexedDB.open()` kérést NEM LEHET VISSZAVONNI. A `Promise.race`
      // időtúllépése csak azt jelenti, hogy MI nem várjuk tovább - a kérés
      // maga ott marad függőben, örökre. Minden újrapróbálkozás tehát egy
      // ÚJABB, örökre függő megnyitást tett a sorba, és az IndexedDB a
      // megnyitási kéréseket SORBAN dolgozza fel: onnantól azon a lapon már
      // SEMMILYEN megnyitás nem futott le - még egy sima, verzió nélküli sem.
      // Éles esetben (2026-09-19, dev) ez oda vezetett, hogy a hibaüzenetet
      // mutató lap maga is részévé vált a torlódásnak, és az oldal frissítése
      // sem segíthetett, csak a lap bezárása.
      //
      // Mostantól EGY próbálkozás van. Az időtúllépés csak arra szolgál, hogy
      // a felhasználó ne nézzen végtelenségig egy pörgő ikont - a hibaüzenet
      // (lent) amúgy is pontosan megmondja, mi a teendő. A blokkolás valódi
      // gyökerét egyébként is máshol szüntettük meg: új mérkőzés már a SAJÁT
      // adatbázisát kapja, amit definíció szerint nem tud blokkolni semmi
      // (l. `public/db.worker.js`, 'legacy' vs 'perMatch').
      const attemptCreateRoom = () => {
        return Promise.race([
          window.dbmanager.createRoom(),
          // 20 mp. A worker legrosszabb esetben (egy másik lap régi buildje
          // eltorlaszolta a közös adatbázist) így dönt: 4 mp a bejelentkezés
          // előtti `initdb('mksz')` gyors hibázása + 3 mp szerkezet-felismerés
          // + 4 mp beragadás-védelem. Mérve: 11 mp, amikor ezek SOROSAN futnak.
          // Az alkalmazásban a bejelentkezés előtti hívás párhuzamosan fut a
          // belépéssel, tehát a valóságban kevesebb - de az időkorlátnak bőven
          // a mért legrosszabb eset FÖLÖTT kell lennie, különben pont a saját
          // védelmünket vágnánk el, és a bíró hibaüzenetet kapna olyankor is,
          // amikor a rendszer magától megoldotta volna.
          new Promise((_, reject) => setTimeout(() => reject(new Error("IDB_BLOCKED_TIMEOUT")), 20000))
        ]);
      };

      // JAVÍTÁS (4514 - Bugsnag-logolás bővítése): a "már meg van nyitva
      // másik böngészőben" hiba korábban SOSEM jelent meg önálló, kereshető
      // hibacsoportként a Bugsnagban - csak közvetett jelekből (pl. a "logged
      // in" próbálkozások szokatlan gyakoriságából) lehetett utólag
      // rekonstruálni, hogy ez történt egy adott meccsen. A localStorage-beli
      // számláló azt mutatja meg, ez hányadik egymást követő, sikertelen
      // próbálkozás UGYANEHHEZ a meccshez ezen az eszközön - sikeres
      // megnyitáskor nullázódik.
      const idbRetryKey = 'mksz_idb_block_retry_' + (data.room || '');

      attemptCreateRoom().then(() => {
        console.log("room created");
        try { localStorage.removeItem(idbRetryKey); } catch (e) { /* ignore */ }
        window.vueio.emit(CONSTANTS.SOCKET.ACTIONS.GETINIT, {});
      }).catch(err => {
        console.error("Adatbázis hiba:", err);
        const errStr = err.toString();

        let errorMsg = "";
        const isBlocked = err.message === "IDB_BLOCKED_TIMEOUT" || errStr.includes('blocked') || errStr.includes("reading 'close'");

        // JAVÍTÁS: a db.worker.js `createRoom()`-ja blokkolás esetén (l.
        // `askWhoIsHere`) megkérdezi a BroadcastChannel-en a többi, ugyanezen
        // origin alatt futó ÉLŐ lapot, ki tartja nyitva a közös adatbázist - a
        // választ (ha érkezett) a hibaüzenetbe kódolva kapjuk meg innen
        // (`blocking_rooms=Merkozes_0_XXX,...` vagy `blocking_rooms=none_responded`,
        // ha senki nem válaszolt az 500ms-es határidőn belül). Ezt itt
        // kibontjuk, hogy a felhasználónak KONKRÉT meccs-azonosítót tudjunk
        // mondani ahelyett, hogy csak annyit írnánk: "valami blokkol".
        const blockingMatch = errStr.match(/blocking_rooms=(\S*)/);
        const blockingRoomsRaw = blockingMatch ? blockingMatch[1] : null;
        let identifiedMatchIds = [];
        if (blockingRoomsRaw && blockingRoomsRaw !== 'none_responded') {
          identifiedMatchIds = blockingRoomsRaw.split(',').filter(Boolean).map(room => room.split('_').pop());
        }
        const noOneResponded = blockingRoomsRaw === 'none_responded';

        let retryCount = 1;
        try {
          retryCount = (parseInt(localStorage.getItem(idbRetryKey), 10) || 0) + 1;
          localStorage.setItem(idbRetryKey, String(retryCount));
        } catch (e) { /* localStorage nem elérhető - ne akadjon el emiatt */ }

        // JAVÍTÁS: a korábbi üzenet ("már meg van nyitva máshol, zárja be és
        // próbálja újra") gyakran NEM oldotta meg a problémát, mert a
        // felhasználó gyakran nem is tudta, HOGY mit kellene bezárnia (l. 26.
        // tétel diagnózisa: a gépen/böngészőn NYITVA FELEJTETT, akár egy
        // TELJESEN MÁS mérkőzéshez tartozó online jegyzőkönyv-lap is
        // blokkolhatja az újat, mert mindegyik egyetlen, közös helyi
        // adatbázist használ - ez a felhasználó számára nem nyilvánvaló, és
        // a gyors, ismételt frissítgetés (F5) inkább ronthat a helyzeten,
        // mint segítene). Az üzenet ezért konkrét, lépésenkénti útmutatást ad,
        // és a korábbi (sikertelen) próbálkozások számától függően egyre
        // határozottabb tanácsot.
        if (isBlocked) {
          if (identifiedMatchIds.length > 0) {
            // JAVÍTÁS: sikerült konkrétan azonosítani, MELYIK meccs blokkol -
            // ez sokkal célzottabb útmutatás, mint az általános "keresse meg".
            errorMsg = `A felületet nem tudjuk megnyitni, mert a <b>${identifiedMatchIds.join(', ')}</b> mérkőzés online jegyzőkönyve nyitva van egy másik lapon/ablakban ugyanebben a böngészőben.` +
                "<br/><br/>Kérjük:<br/>1. Keresse meg és zárja be azt a lapot/ablakot.<br/>2. Utána frissítse ezt az oldalt.";
          } else if (noOneResponded) {
            // JAVÍTÁS: megkérdeztük a többi lapot, de SENKI nem válaszolt -
            // ez arra utal, hogy valószínűleg nem egy élő, másik felhasználó
            // blokkol, hanem egy elakadt/háttérbe fagyott lap - ilyenkor a
            // "keresse meg a másik lapot" tanács kevésbé hasznos, mint a
            // böngésző teljes újraindítása.
            errorMsg = "A felületet nem tudjuk megnyitni. Egy korábbi, elakadt böngészőlap tarthatja foglalva az adatbázist (nem sikerült azonosítani, melyik aktív lap okozza)." +
                "<br/><br/>Kérjük: zárja be a TELJES böngészőt (az összes ablakával/lapjával együtt), várjon néhány másodpercet, majd nyissa meg újra ezt a linket.";
          } else {
            errorMsg = "A felületet nem tudjuk megnyitni, mert valószínűleg egy másik, nyitva felejtett böngészőlap/ablak foglalja - akár egy MÁSIK mérkőzés online jegyzőkönyve is, ha azt ugyanebben a böngészőben nyitották meg." +
                "<br/><br/>Kérjük:<br/>1. Ellenőrizze, nincs-e más lapon/ablakban megnyitva ez vagy egy másik online jegyzőkönyv ugyanebben a böngészőben, és zárja be azokat.<br/>2. Utána frissítse ezt az oldalt.";
          }
          if (retryCount >= 3) {
            errorMsg += "<br/><br/>Mivel a frissítés eddig nem segített: NE csak ezt a lapot frissítse - zárja be a TELJES böngészőt (az összes ablakával/lapjával együtt), várjon néhány másodpercet, majd nyissa meg újra ezt a linket egyetlen alkalommal.";
          }
        } else {
          errorMsg = "Hiba történt az adatbázis inicializálásakor. Kérjük, frissítse az oldalt!";
        }

        Bugsnag.notify(err, function (event) {
          event.severity = isBlocked ? 'warning' : 'error';
          event.context = 'DB init failed (' + (isBlocked ? 'blocked' : 'other') + ') - ' + (data.room || '');
          event.addMetadata('db_init', {
            blocked: isBlocked,
            retryCount: retryCount,
            room: data.room,
            roomsize: data.roomsize,
            merkozesId: params.get('merkozesId'),
            usertype: data.type,
            blockingRoomsRaw: blockingRoomsRaw
          });
        });

        // JAVÍTÁS: A hibaüzenetet közvetlenül a töltőképernyőre (connection_status) írjuk ki pirossal.
        // Nem kapcsoljuk le az overlay-t, így a felhasználó látja a folyamatot és a hiba okát.
        self.connection_status += `<br/><br/><span style="color: #FF5252; font-weight: bold; font-size: 1.2em;">HIBÁS MŰKÖDÉS:<br/>${errorMsg}</span>`;
      });
    },
    // JAVÍTÁS (77. tétel): a korábbi mérés nem várta meg a letöltést (a
    // `response.blob()` elől hiányzott az `await`), így valójában csak az első
    // válaszbájtig eltelt időt mérte, és abból számolt egy 5 MB-os letöltést - a
    // Bugsnagben látott 75-600 "Mbps" értékek ezért értelmetlenek voltak. A fájl
    // ettől még a háttérben teljes egészében letöltődött: minden belépés 5 MB
    // mobiladatot és egy 5 MB-os memóriafoglalást jelentett.
    // Most a választ ténylegesen olvassuk, de legfeljebb MAX_BYTES-ig vagy
    // TIMEOUT_MS-ig, utána megszakítjuk a letöltést. A sebességet a ténylegesen
    // beérkezett bájtokból és az első bájt utáni időből számoljuk, a válaszidőt
    // (ttfbMs) pedig külön adjuk vissza.
    async measureDownloadSpeed() {
      const url = `https://cdn.mksz.hu/mkszhu-public/5MB.zip`;
      const MAX_BYTES = 512 * 1024;
      const TIMEOUT_MS = 4000;

      const controller = (typeof AbortController !== 'undefined') ? new AbortController() : null;
      const timer = controller ? setTimeout(() => controller.abort(), TIMEOUT_MS) : null;
      const startTime = performance.now();
      let firstByteTime = null;
      let bytes = 0;

      try {
        const response = await fetch(url, {cache: "no-store", signal: controller ? controller.signal : undefined});
        firstByteTime = performance.now();

        if (response.body && typeof response.body.getReader === 'function') {
          const reader = response.body.getReader();
          while (bytes < MAX_BYTES) {
            const {done, value} = await reader.read();
            if (done) break;
            bytes += value ? value.byteLength : 0;
          }
          if (controller) controller.abort();
        } else {
          // Stream-olvasás nélküli böngésző: nincs mérés, nem töltünk le 5 MB-ot.
          if (controller) controller.abort();
        }
      } catch (err) {
        // Az időkorlát miatti megszakítás itt landol - az addig beérkezett
        // bájtokból még számolunk.
        if (!(err && err.name === 'AbortError')) {
          console.error("Error measuring speed:", err);
        }
      } finally {
        if (timer) clearTimeout(timer);
      }

      const endTime = performance.now();
      const ttfbMs = firstByteTime !== null ? Math.round(firstByteTime - startTime) : null;
      const transferSeconds = firstByteTime !== null ? (endTime - firstByteTime) / 1000 : 0;
      const downloadSpeed = (bytes > 0 && transferSeconds > 0) ? (bytes * 8) / transferSeconds / 1e6 : null;

      console.log(`Download Speed: ${downloadSpeed !== null ? downloadSpeed.toFixed(2) : '-'} Mbps (${bytes} B, TTFB ${ttfbMs} ms)`);
      return {downloadSpeed, ttfbMs, bytes, durationMs: Math.round(endTime - startTime)};
    },
    login() {
      this.warning = "";

      if (this.username === "" || this.password === "") {
        this.warning = "Felhasználónév vagy jelszó nem lehet üres.";
        return;
      }

      window.vueio.emit(CONSTANTS.SOCKET.ACTIONS.LOGIN, {
        username: this.username,
        password: this.password
      });

      this.SET_OVERLAY(true);
    },
    getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }
  }
};
</script>

<style scoped>
#inspire {
  display: flex;
  flex-flow: row;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  width: 100%;
  height: 100%;
}
</style>
